import React, { useCallback, useMemo } from "react"
import { Table } from "antd"

import { Bold, Value } from "@components/Text"
import InputDistributionAmount from "../InputDistributionAmount"

const LABEL_INVESTOR = "Beneficiary"
const LABEL_EMAIL = "Email"
const LABEL_AMOUNT = "Invested Amount"
const LABEL_CLASS = "Class"
const LABEL_RATE = "Return Rate"
const LABEL_DISTRIBUTION_AMOUNT = "Amount"

const useColumns = (amountByKey, customAmountByKey, setCustomAmountByKey, selectedRowKeys) => {
  const onAmountClear = useCallback((key) => {
    setCustomAmountByKey(previous => {
      const { [key]: _, ...rest } = previous
      return rest
    })
  }, [ setCustomAmountByKey ])

  const onAmountChange = useCallback((key, value) => {
    if (!value) {
      return onAmountClear(key)
    }

    setCustomAmountByKey(previous => ({
      ...previous,
      [key]: value,
    }))
  }, [ setCustomAmountByKey, onAmountClear ])

  return useMemo(() => ([
    {
      key: "investor",
      title: LABEL_INVESTOR,
      dataIndex: "investor",
      width: "30%",
      render: value => <Bold>{value}</Bold>,
    },
    {
      key: "email",
      title: LABEL_EMAIL,
      dataIndex: "email",
      width: "30%",
    },
    {
      key: "investedAmount",
      title: LABEL_AMOUNT,
      dataIndex: "investedAmount",
      width: "10%",
      render: value => <Value value={value} />,
    },
    {
      key: "className",
      title: LABEL_CLASS,
      dataIndex: "className",
      width: "10%",
    },
    {
      key: "returnRate",
      title: LABEL_RATE,
      dataIndex: "returnRate",
      width: "10%",
      render: value => `${value || 0}%`,
    },
    {
      key: "amount",
      title: LABEL_DISTRIBUTION_AMOUNT,
      width: "10%",
      render: (_, { key }) => (
        <InputDistributionAmount
          disabled={!selectedRowKeys.includes(key)}
          valueInCents={amountByKey[key]}
          isCustom={customAmountByKey[key] !== undefined}
          onChange={value => onAmountChange(key, value)}
          onClear={() => onAmountClear(key)}
        />
      ),
    },
    Table.SELECTION_COLUMN,
  ]), [ amountByKey, customAmountByKey, onAmountChange, onAmountClear, selectedRowKeys ])
}

export default useColumns
